import {scaleLinear} from 'd3-scale';

const ColorLibrary = {
  transparent: `rgba(0,0,0,0)`,
  redGradient7Step: ['#ffffb2','#fed976','#feb24c','#fd8d3c','#fc4e2a','#e31a1c','#b10026'],
  redGradient8Step: ['#ffffcc','#ffeda0','#fed976','#feb24c','#fd8d3c','#fc4e2a','#e31a1c','#b10026']
};

const colorFromSteps = (value, steps, colors, defaultColor='#000') => {
  for (let i = 0; i<steps.length - 1; i++) {
    if (steps[i] <= value && value <= steps[i+1]) {
      return colors[i];
    }
  }
  return defaultColor;
};

const constantStepCalculator = (numSteps, min, max) => {
  const d = (max-min)/numSteps;
  let domain = [min];
  for (let i = 1; i <= numSteps; i++) {
    domain.push(Math.round(min + (d*i)));
  }
  return domain;
}

const colorMapsFromMinMaxFactory = ({colorSteps, min, max, transparentValues}) => {
  const numSteps = colorSteps.length;
  const domain = constantStepCalculator(numSteps, min, max)
  const colorTransform = scaleLinear()
    .range(colorSteps)
    .domain(domain);

  return ([value]) => {
    if (value <= min || value >= max || transparentValues.includes(value)) {
      return ColorLibrary.transparent;
    }
    return colorTransform(value);
  }
};

const riskConfigStyleFunctionGenerator = (featureInfo, steps, colors) => {
  const getColor = (risk) => {
    return colorFromSteps(parseInt(risk), steps, colors, 'white');
  };

  return {
    stroke: false,
    color: getColor(featureInfo.risk),
    fill: true,
    fillOpacity: 1
  }
}


export {
  ColorLibrary,
  colorFromSteps,
  colorMapsFromMinMaxFactory,
  riskConfigStyleFunctionGenerator,
  constantStepCalculator
}